import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import LoadingIndicator from 'ui/LoadingIndicator';
import { linkAccounts } from 'services/api/linkAccountsApi';
import { sendErrorToSentry } from 'utils/sentryHelpers';

const LinkAccounts = ({ children }) => {
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    linkAccounts()
      .catch(sendErrorToSentry)
      .finally(() => setIsReady(true));
  }, []);

  if (!isReady) {
    return <LoadingIndicator cover />;
  }

  return children;
};

LinkAccounts.propTypes = {
  children: PropTypes.node.isRequired
};

export default LinkAccounts;
